import angular from 'angular';

const isOpera = (!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
const isFirefox = typeof InstallTrigger !== 'undefined';
const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]'; })(!window['safari'] || (typeof window.safari !== 'undefined' && window.safari.pushNotification));
const isIE = /*@cc_on!@*/false || !!document.documentMode;
const isEdge = !isIE && !!window.StyleMedia;
const isChrome = !!window.chrome;
const isBlink = (isChrome || isOpera) && !!window.CSS;

export function BrowserService() {
    const isMobile = () => window.innerWidth < 1024;
    const isDesktop = () => window.innerWidth >= 1024;

    return {
        isOpera,
        isFirefox,
        isSafari,
        isIE,
        isEdge,
        isChrome,
        isBlink,
        isMobile,
        isDesktop,
    };
}

angular.module('TALENYA-FE').factory('BrowserService', BrowserService);
